import { createContext, useContext, useState, useCallback } from 'react'

const LoginModalContext = createContext(null)

export const LoginModalProvider = ({ children }) => {
  const [loginModalOpen, setLoginModalOpen] = useState(false)
  const [loginContext, setLoginContext] = useState(null) // 'general' or programSlug

  const openLoginModal = useCallback((context = 'general') => {
    setLoginContext(context)
    setLoginModalOpen(true)
  }, [])

  const closeLoginModal = useCallback(() => {
    setLoginModalOpen(false)
    setLoginContext(null)
  }, [])

  return (
    <LoginModalContext.Provider value={{ loginModalOpen, loginContext, openLoginModal, closeLoginModal, setLoginModalOpen, setLoginContext }}>
      {children}
    </LoginModalContext.Provider>
  )
}

export const useLoginModal = () => {
  const context = useContext(LoginModalContext)
  if (!context) {
    throw new Error('useLoginModal must be used within a LoginModalProvider')
  }
  return context
}

export default LoginModalContext
